import * as Factory from 'factory.ts'
import faker from 'faker'

import { type UserSettingApiModel } from '@webapp/platform/iam/data-access/api-models/UserSettingApiModel'
import { EditVarianceType } from '@webapp/platform/iam/entities/enums/EditVarianceTypeEnum'

export const UserSettingApiModelStub =
  Factory.Sync.makeFactory<UserSettingApiModel>({
    id: Factory.each(() => faker.random.number()),
    edit_variance_type: Factory.each(() =>
      faker.random.arrayElement(Object.values(EditVarianceType))
    ),
    modified_datetime: Factory.each(() => faker.date.past(10).toISOString()),
    restrict_editable_variance: true,
    variance_threshold_limit: Factory.each(() =>
      faker.random.number().toString()
    ),
  })
